<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
  async created() {
    try {
      await this.$auth.renewTokens()
    } catch (e) {
      // console.log(e);
    }
  }
}
</script>

<style lang="css">
  [class^="SupportFloatPage-floatBox_"] {
    z-index: 1000000 !important;
    max-width: calc(100% - 40px);
  }
</style>
